function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 155 155"
}, props), React.createElement("path", {
  d: "M37 0v37H0V21.908c-.1-4.544 2.483-9.331 7.75-14.362C13.017 2.516 17.934 0 22.5 0H37zm22 0v96h95.993L155 27c-.204-5.678-2.756-11.598-7.653-17.759C142.449 3.081 136 0 128 0H59zM37.003 155v-37h-37v15.092c-.1 4.544 2.483 9.331 7.75 14.362 5.267 5.03 10.183 7.546 14.75 7.546h14.5zM118 155v-37h37v15.092c.1 4.544-2.483 9.331-7.75 14.362-5.267 5.03-10.184 7.546-14.75 7.546H118zM0 59h37v37H0zm59 59h37v37H59z"
})));